import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { BackgroundJobsService } from '../../../core/services/background-jobs.service';

@Component({
  selector: 'adf-background-jobs-indicator',
  standalone: true,
  imports: [NgbTooltip],
  templateUrl: './background-jobs-indicator.component.html',
  styleUrl: './background-jobs-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackgroundJobsIndicatorComponent {
  private readonly _bgJobsService = inject(BackgroundJobsService);

  readonly jobs = toSignal(this._bgJobsService.jobs$, { initialValue: [] });
}
